
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/input-base",
      function () {
        return require("private-next-pages/material-ui/api/input-base.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/input-base"])
      });
    }
  